// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;600;700&family=Lexend:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Primitive colors — Figma 39:592 */
  --teal-50: #f0f8f7;
  --teal-100: #dcefec;
  --teal-200: #b6ded8;
  --teal-300: #83c7be;
  --teal-400: #43a79c;
  --teal-500: #168a80;
  --teal-600: #0f766e;
  --teal-700: #0c5f59;
  --teal-800: #0a4a46;
  --teal-900: #083836;
  --teal-950: #052524;
  --neutral-0: #fff;
  --neutral-50: #f4f7f7;
  --neutral-100: #e8edec;
  --neutral-150: #dce3e2;
  --neutral-200: #cdd6d4;
  --neutral-300: #aebab8;
  --neutral-400: #8a9896;
  --neutral-500: #6b7b78;
  --neutral-600: #506360;
  --neutral-700: #3a4d4a;
  --neutral-800: #253836;
  --neutral-900: #142624;
  --neutral-950: #0a1614;
  --red-50: #fef2f1;
  --red-100: #fde3e1;
  --red-200: #fbc5c0;
  --red-300: #f59b93;
  --red-400: #ed6b5f;
  --red-500: #e04434;
  --red-600: #c23a2b;
  --red-700: #a3301f;
  --red-800: #872b1d;
  --red-900: #6f291e;
  --green-50: #edfbf2;
  --green-100: #d4f5e0;
  --green-200: #ace9c5;
  --green-300: #76d8a2;
  --green-400: #3ec17c;
  --green-500: #1c8a4c;
  --green-600: #15703d;
  --green-700: #115a33;
  --green-800: #10472a;
  --green-900: #0e3b24;
  --amber-50: #fef8ec;
  --amber-100: #fceec9;
  --amber-200: #f9d98f;
  --amber-300: #f5bd54;
  --amber-400: #e9a020;
  --amber-500: #b7701a;
  --amber-600: #9a5b14;
  --amber-700: #7d4412;
  --amber-800: #663714;
  --amber-900: #552e16;
  --blue-50: #eff6ff;
  --blue-100: #dbe9fe;
  --blue-200: #bfdbfe;
  --blue-300: #93c5fd;
  --blue-400: #60a5fa;
  --blue-500: #3b82f6;
  --blue-600: #2563eb;
  --blue-700: #1d4ed8;
  --blue-800: #1e40af;
  --blue-900: #1e3a8a;

  /* Semantic colors — light mode, Figma 39:594 */
  --bg-primary: var(--neutral-50);
  --bg-secondary: var(--neutral-100);
  --bg-tertiary: var(--neutral-150);
  --surface-primary: var(--neutral-0);
  --surface-secondary: var(--neutral-50);
  --surface-tertiary: var(--neutral-100);
  --surface-elevated: var(--neutral-0);
  --border-default: var(--neutral-200);
  --border-strong: var(--neutral-300);
  --border-subtle: var(--neutral-150);
  --text-primary: var(--neutral-900);
  --text-secondary: var(--neutral-600);
  --text-tertiary: var(--neutral-500);
  --text-disabled: var(--neutral-400);
  --text-inverse: var(--neutral-0);
  --text-link: var(--teal-600);
  --interactive-default: var(--teal-600);
  --interactive-hover: var(--teal-700);
  --interactive-pressed: var(--teal-800);
  --interactive-disabled: var(--neutral-200);
  --interactive-soft: var(--teal-50);
  --interactive-soft-hover: var(--teal-100);
  --interactive-selected: var(--teal-100);
  --on-interactive-primary: var(--neutral-0);
  --on-interactive-disabled: var(--neutral-400);
  --focus-ring: var(--teal-200);
  --danger-default: var(--red-600);
  --danger-soft: var(--red-50);
  --danger-text: var(--red-700);
  --danger-border: var(--red-200);
  --success-default: var(--green-600);
  --success-soft: var(--green-50);
  --success-text: var(--green-700);
  --success-border: var(--green-200);
  --warning-default: var(--amber-500);
  --warning-soft: var(--amber-50);
  --warning-text: var(--amber-700);
  --warning-border: var(--amber-200);
  --info-default: var(--blue-600);
  --info-soft: var(--blue-50);
  --info-text: var(--blue-700);
  --info-border: var(--blue-200);
  --money-overdue: var(--red-600);
  --money-overdue-soft: var(--red-50);
  --money-paid: var(--green-600);
  --money-paid-soft: var(--green-50);
  --money-pending: var(--amber-500);
  --money-pending-soft: var(--amber-50);
  --money-draft: var(--neutral-500);
  --money-draft-soft: var(--neutral-100);
  --chart-primary: var(--teal-600);
  --chart-secondary: #aebab8;
  --chart-tertiary: var(--teal-300);
  --chart-danger: var(--red-500);
  --chart-success: var(--green-500);
  --chart-grid: var(--neutral-200);
  --overlay-default: rgba(10, 22, 20, 0.4);
  --overlay-heavy: rgba(10, 22, 20, 0.7);
  --toast-bg: var(--neutral-900);
  --toast-text: var(--neutral-50);

  /* Brand gradient — Figma 72:89 */
  --brand-gradient-start: #3af0f3;
  --brand-gradient-mid: #0fbac4;
  --brand-gradient-end: #0a7489;
  --brand-gradient: linear-gradient(
    135deg,
    var(--brand-gradient-start) 0%,
    var(--brand-gradient-mid) 45%,
    var(--brand-gradient-end) 100%
  );

  /* Typography — desktop defaults, Figma 48:6 */
  --font-family-primary: "Lexend", sans-serif;
  --font-family-mono: "JetBrains Mono", monospace;
  --font-weight-light: 300;
  --font-weight-regular: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  --font-size-display-hero: 56px;
  --line-height-display-hero: 1.1;
  --letter-spacing-display-hero: -1.12px;
  --font-size-display-lg: 48px;
  --line-height-display-lg: 1.15;
  --letter-spacing-display-lg: -0.96px;
  --font-size-display-md: 40px;
  --line-height-display-md: 1.2;
  --letter-spacing-display-md: -0.6px;
  --font-size-h1: 32px;
  --line-height-h1: 1.25;
  --letter-spacing-h1: -0.48px;
  --font-size-h2: 28px;
  --line-height-h2: 1.3;
  --letter-spacing-h2: -0.28px;
  --font-size-h3: 22px;
  --line-height-h3: 1.35;
  --letter-spacing-h3: -0.22px;
  --font-size-h4: 18px;
  --line-height-h4: 1.4;
  --letter-spacing-h4: -0.09px;
  --font-size-h5: 16px;
  --line-height-h5: 1.4;
  --letter-spacing-h5: 0;
  --font-size-h6: 14px;
  --line-height-h6: 1.45;
  --letter-spacing-h6: 0;
  --font-size-body-lg: 18px;
  --line-height-body-lg: 1.6;
  --letter-spacing-body-lg: 0;
  --font-size-body-md: 16px;
  --line-height-body-md: 1.6;
  --letter-spacing-body-md: 0;
  --font-size-body-sm: 14px;
  --line-height-body-sm: 1.55;
  --letter-spacing-body-sm: 0;
  --font-size-body-xs: 12px;
  --line-height-body-xs: 1.5;
  --letter-spacing-body-xs: 0.12px;
  --font-size-label-lg: 16px;
  --line-height-label-lg: 1.3;
  --letter-spacing-label-lg: 0;
  --font-size-label-md: 14px;
  --line-height-label-md: 1.3;
  --letter-spacing-label-md: 0.07px;
  --font-size-label-sm: 12px;
  --line-height-label-sm: 1.3;
  --letter-spacing-label-sm: 0.12px;
  --font-size-caption-md: 13px;
  --line-height-caption-md: 1.4;
  --letter-spacing-caption-md: 0.065px;
  --font-size-caption-sm: 11px;
  --line-height-caption-sm: 1.45;
  --letter-spacing-caption-sm: 0.12px;
  --font-size-overline: 11px;
  --line-height-overline: 1.3;
  --letter-spacing-overline: 0.88px;
  --font-size-doc-number: 14px;
  --line-height-doc-number: 1.3;
  --letter-spacing-doc-number: 0.28px;
  --font-size-money-hero: 56px;
  --line-height-money-hero: 1.1;
  --letter-spacing-money-hero: -1.12px;
  --font-size-money-lg: 22px;
  --line-height-money-lg: 1.2;
  --letter-spacing-money-lg: 0;
  --font-size-money-md: 16px;
  --line-height-money-md: 1.3;
  --letter-spacing-money-md: 0;
  --font-size-money-sm: 14px;
  --line-height-money-sm: 1.3;
  --letter-spacing-money-sm: 0;

  /* Spacing, controls, radii, elevation — Figma 54:37 */
  --space-0: 0;
  --space-px: 1px;
  --space-1: 4px;
  --space-2: 8px;
  --space-3: 12px;
  --space-4: 16px;
  --space-5: 20px;
  --space-6: 24px;
  --space-8: 32px;
  --space-10: 40px;
  --space-12: 48px;
  --space-16: 64px;
  --space-20: 80px;
  --space-24: 96px;
  --control-sm: 32px;
  --control-md: 40px;
  --control-lg: 48px;
  --radius-none: 0;
  --radius-xs: 4px;
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 14px;
  --radius-xl: 20px;
  --radius-pill: 999px;
  --radius-full: 9999px;
  --elevation-none: none;
  --elevation-small: 0 1px 2px rgba(14, 26, 32, 0.06);
  --elevation-medium: 0 1px 2px rgba(14, 26, 32, 0.04),
    0 6px 16px -4px rgba(14, 26, 32, 0.1);
  --elevation-large: 0 2px 6px rgba(14, 26, 32, 0.06),
    0 24px 48px -12px rgba(14, 26, 32, 0.22);
  --elevation-xlarge: 0 4px 8px rgba(14, 26, 32, 0.08),
    0 32px 64px -16px rgba(14, 26, 32, 0.28);
  /* Focus uses borders or solid keyboard outlines instead of a glow. */
  --focus-shadow: none;

  /* Iconography — Figma 59:8 */
  --icon-xs: 12px;
  --icon-sm: 16px;
  --icon-md: 20px;
  --icon-lg: 24px;
  --icon-xl: 32px;
  --icon-stroke: 2px;

  /* Motion — Figma 67:130 */
  --duration-instant: 0ms;
  --duration-fast: 100ms;
  --duration-normal: 200ms;
  --duration-moderate: 300ms;
  --duration-slow: 400ms;
  --duration-slower: 500ms;
  --easing-out: cubic-bezier(0.16, 1, 0.3, 1);
  --easing-in: cubic-bezier(0.55, 0, 1, 0.45);
  --easing-in-out: cubic-bezier(0.45, 0, 0.55, 1);
  --easing-linear: linear;
}

[data-theme="dark"],
.theme-dark {
  --bg-primary: #101113;
  --bg-secondary: #17191c;
  --bg-tertiary: #202328;
  --surface-primary: #191b1f;
  --surface-secondary: #22252a;
  --surface-tertiary: #2b2f35;
  --surface-elevated: #25282e;
  --border-default: #3a3f47;
  --border-strong: #69727e;
  --border-subtle: #2c3036;
  --text-primary: #f2f3f5;
  --text-secondary: #b3b8c2;
  --text-tertiary: #9299a5;
  --text-disabled: #616975;
  --text-inverse: #101113;
  --text-link: #83c7be;
  --interactive-default: #43a79c;
  --interactive-hover: #83c7be;
  --interactive-pressed: #b6ded8;
  --interactive-disabled: #30343b;
  --interactive-soft: #22252a;
  --interactive-soft-hover: #2b2f35;
  --interactive-selected: #083836;
  --on-interactive-primary: #101113;
  --on-interactive-disabled: #727b88;
  --focus-ring: #71c9be;
  --danger-default: #f08078;
  --danger-soft: #332022;
  --danger-text: #f3aaa4;
  --danger-border: #614047;
  --success-default: #61bc8c;
  --success-soft: #1b2d25;
  --success-text: #94d3af;
  --success-border: #3f6650;
  --warning-default: #ddb56b;
  --warning-soft: #342b1d;
  --warning-text: #e6c78c;
  --warning-border: #695638;
  --info-default: #7fa8db;
  --info-soft: #1e2b3c;
  --info-text: #aec9ec;
  --info-border: #415c82;
  --overlay-default: #0009;
  --overlay-heavy: #000c;
  --toast-bg: #25282e;
  --toast-text: #f2f3f5;
  --money-overdue: #f08078;
  --money-overdue-soft: #332022;
  --money-paid: #61bc8c;
  --money-paid-soft: #1b2d25;
  --money-pending: #ddb56b;
  --money-pending-soft: #342b1d;
  --money-draft: #b3b8c2;
  --money-draft-soft: #22252a;
  --chart-primary: #43a79c;
  --chart-secondary: #77817c;
  --chart-tertiary: #97a6bf;
  --chart-danger: #f08078;
  --chart-success: #61bc8c;
  --chart-grid: #343940;
}

/* Semantic type styles from the shared Figma typography scale (48:6). */
.type-display-hero {
  font: var(--font-weight-light) var(--font-size-display-hero) /
    var(--line-height-display-hero) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-display-hero);
}
.type-display-lg {
  font: var(--font-weight-light) var(--font-size-display-lg) /
    var(--line-height-display-lg) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-display-lg);
}
.type-display-md {
  font: var(--font-weight-light) var(--font-size-display-md) /
    var(--line-height-display-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-display-md);
}
.type-h1 {
  font: var(--font-weight-semibold) var(--font-size-h1) / var(--line-height-h1)
    var(--font-family-primary);
  letter-spacing: var(--letter-spacing-h1);
}
.type-h2 {
  font: var(--font-weight-semibold) var(--font-size-h2) / var(--line-height-h2)
    var(--font-family-primary);
  letter-spacing: var(--letter-spacing-h2);
}
.type-h3 {
  font: var(--font-weight-medium) var(--font-size-h3) / var(--line-height-h3)
    var(--font-family-primary);
  letter-spacing: var(--letter-spacing-h3);
}
.type-h4 {
  font: var(--font-weight-medium) var(--font-size-h4) / var(--line-height-h4)
    var(--font-family-primary);
  letter-spacing: var(--letter-spacing-h4);
}
.type-h5 {
  font: var(--font-weight-medium) var(--font-size-h5) / var(--line-height-h5)
    var(--font-family-primary);
  letter-spacing: var(--letter-spacing-h5);
}
.type-h6 {
  font: var(--font-weight-medium) var(--font-size-h6) / var(--line-height-h6)
    var(--font-family-primary);
  letter-spacing: var(--letter-spacing-h6);
}
.type-body-lg {
  font: var(--font-weight-regular) var(--font-size-body-lg) /
    var(--line-height-body-lg) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-body-lg);
}
.type-body-md {
  font: var(--font-weight-regular) var(--font-size-body-md) /
    var(--line-height-body-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-body-md);
}
.type-body-sm {
  font: var(--font-weight-regular) var(--font-size-body-sm) /
    var(--line-height-body-sm) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-body-sm);
}
.type-body-xs {
  font: var(--font-weight-regular) var(--font-size-body-xs) /
    var(--line-height-body-xs) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-body-xs);
}
.type-label-lg {
  font: var(--font-weight-medium) var(--font-size-label-lg) /
    var(--line-height-label-lg) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-label-lg);
}
.type-label-md {
  font: var(--font-weight-medium) var(--font-size-label-md) /
    var(--line-height-label-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-label-md);
}
.type-label-sm {
  font: var(--font-weight-medium) var(--font-size-label-sm) /
    var(--line-height-label-sm) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-label-sm);
}
.type-caption-md {
  font: var(--font-weight-regular) var(--font-size-caption-md) /
    var(--line-height-caption-md) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-caption-md);
}
.type-caption-sm {
  font: var(--font-weight-regular) var(--font-size-caption-sm) /
    var(--line-height-caption-sm) var(--font-family-primary);
  letter-spacing: var(--letter-spacing-caption-sm);
}
.type-doc-number {
  font: var(--font-weight-medium) var(--font-size-doc-number) /
    var(--line-height-doc-number) var(--font-family-mono);
  letter-spacing: var(--letter-spacing-doc-number);
}
.type-money-hero {
  font: var(--font-weight-bold) var(--font-size-money-hero) /
    var(--line-height-money-hero) var(--font-family-mono);
  letter-spacing: var(--letter-spacing-money-hero);
}
.type-money-lg {
  font: var(--font-weight-bold) var(--font-size-money-lg) /
    var(--line-height-money-lg) var(--font-family-mono);
  letter-spacing: var(--letter-spacing-money-lg);
}
.type-money-md {
  font: var(--font-weight-medium) var(--font-size-money-md) /
    var(--line-height-money-md) var(--font-family-mono);
  letter-spacing: var(--letter-spacing-money-md);
}
.type-money-sm {
  font: var(--font-weight-regular) var(--font-size-money-sm) /
    var(--line-height-money-sm) var(--font-family-mono);
  letter-spacing: var(--letter-spacing-money-sm);
}

@media (max-width: 1023px) {
  :root {
    --font-size-display-hero: 48px;
    --font-size-display-lg: 40px;
    --font-size-display-md: 34px;
    --font-size-h1: 28px;
    --font-size-h2: 24px;
    --font-size-h3: 20px;
    --font-size-h4: 17px;
    --font-size-h5: 15px;
    --font-size-h6: 13px;
    --font-size-body-lg: 17px;
    --font-size-body-md: 15px;
    --font-size-body-sm: 13px;
    --font-size-body-xs: 12px;
    --font-size-label-lg: 15px;
    --font-size-label-md: 13px;
    --font-size-label-sm: 12px;
    --font-size-money-hero: 48px;
    --font-size-money-lg: 20px;
    --font-size-money-md: 15px;
    --font-size-money-sm: 13px;
  }
}
@media (max-width: 600px) {
  :root {
    --font-size-display-hero: 36px;
    --font-size-display-lg: 32px;
    --font-size-display-md: 28px;
    --font-size-h1: 24px;
    --font-size-h2: 20px;
    --font-size-h3: 18px;
    --font-size-h4: 16px;
    --font-size-h5: 15px;
    --font-size-h6: 13px;
    --font-size-body-lg: 17px;
    --font-size-body-md: 15px;
    --font-size-body-sm: 13px;
    --font-size-body-xs: 12px;
    --font-size-label-lg: 15px;
    --font-size-label-md: 13px;
    --font-size-label-sm: 11px;
    --font-size-money-hero: 36px;
    --font-size-money-lg: 20px;
    --font-size-money-md: 15px;
    --font-size-money-sm: 13px;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/design-tokens.css"],"names":[],"mappings":"AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,+CAA+C;EAC/C,+BAA+B;EAC/B,kCAAkC;EAClC,iCAAiC;EACjC,mCAAmC;EACnC,sCAAsC;EACtC,sCAAsC;EACtC,oCAAoC;EACpC,oCAAoC;EACpC,mCAAmC;EACnC,mCAAmC;EACnC,kCAAkC;EAClC,oCAAoC;EACpC,mCAAmC;EACnC,mCAAmC;EACnC,gCAAgC;EAChC,4BAA4B;EAC5B,sCAAsC;EACtC,oCAAoC;EACpC,sCAAsC;EACtC,0CAA0C;EAC1C,kCAAkC;EAClC,yCAAyC;EACzC,uCAAuC;EACvC,0CAA0C;EAC1C,6CAA6C;EAC7C,6BAA6B;EAC7B,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,mCAAmC;EACnC,+BAA+B;EAC/B,gCAAgC;EAChC,kCAAkC;EAClC,mCAAmC;EACnC,+BAA+B;EAC/B,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,mCAAmC;EACnC,8BAA8B;EAC9B,kCAAkC;EAClC,iCAAiC;EACjC,qCAAqC;EACrC,iCAAiC;EACjC,sCAAsC;EACtC,gCAAgC;EAChC,0BAA0B;EAC1B,iCAAiC;EACjC,8BAA8B;EAC9B,iCAAiC;EACjC,gCAAgC;EAChC,wCAAwC;EACxC,sCAAsC;EACtC,8BAA8B;EAC9B,+BAA+B;;EAE/B,iCAAiC;EACjC,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;EAC7B;;;;;GAKC;;EAED,8CAA8C;EAC9C,2CAA2C;EAC3C,+CAA+C;EAC/C,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,sCAAsC;EACtC,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,4BAA4B;EAC5B,6BAA6B;EAC7B,mCAAmC;EACnC,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;EACpC,4BAA4B;EAC5B,8BAA8B;EAC9B,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;EAC7B,mCAAmC;EACnC,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;;EAE5B,sDAAsD;EACtD,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,mDAAmD;EACnD;yCACuC;EACvC;4CAC0C;EAC1C;4CAC0C;EAC1C,qEAAqE;EACrE,oBAAoB;;EAEpB,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;;EAElB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,2CAA2C;EAC3C,2CAA2C;EAC3C,+CAA+C;EAC/C,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;EAC/B,iCAAiC;EACjC,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;EACxB,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,wEAAwE;AACxE;EACE;8DAC4D;EAC5D,kDAAkD;AACpD;AACA;EACE;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;EACE;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;EACE;8BAC4B;EAC5B,wCAAwC;AAC1C;AACA;EACE;8BAC4B;EAC5B,wCAAwC;AAC1C;AACA;EACE;8BAC4B;EAC5B,wCAAwC;AAC1C;AACA;EACE;8BAC4B;EAC5B,wCAAwC;AAC1C;AACA;EACE;8BAC4B;EAC5B,wCAAwC;AAC1C;AACA;EACE;8BAC4B;EAC5B,wCAAwC;AAC1C;AACA;EACE;yDACuD;EACvD,6CAA6C;AAC/C;AACA;EACE;yDACuD;EACvD,6CAA6C;AAC/C;AACA;EACE;yDACuD;EACvD,6CAA6C;AAC/C;AACA;EACE;yDACuD;EACvD,6CAA6C;AAC/C;AACA;EACE;0DACwD;EACxD,8CAA8C;AAChD;AACA;EACE;0DACwD;EACxD,8CAA8C;AAChD;AACA;EACE;0DACwD;EACxD,8CAA8C;AAChD;AACA;EACE;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;EACE;4DAC0D;EAC1D,gDAAgD;AAClD;AACA;EACE;yDACuD;EACvD,gDAAgD;AAClD;AACA;EACE;yDACuD;EACvD,gDAAgD;AAClD;AACA;EACE;uDACqD;EACrD,8CAA8C;AAChD;AACA;EACE;uDACqD;EACrD,8CAA8C;AAChD;AACA;EACE;uDACqD;EACrD,8CAA8C;AAChD;;AAEA;EACE;IACE,8BAA8B;IAC9B,4BAA4B;IAC5B,4BAA4B;IAC5B,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,4BAA4B;IAC5B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,8BAA8B;IAC9B,4BAA4B;IAC5B,4BAA4B;IAC5B,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,4BAA4B;IAC5B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;EAC5B;AACF;AACA;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;600;700&family=Lexend:wght@300;400;500;600;700&display=swap\");\n\n:root {\n  /* Primitive colors — Figma 39:592 */\n  --teal-50: #f0f8f7;\n  --teal-100: #dcefec;\n  --teal-200: #b6ded8;\n  --teal-300: #83c7be;\n  --teal-400: #43a79c;\n  --teal-500: #168a80;\n  --teal-600: #0f766e;\n  --teal-700: #0c5f59;\n  --teal-800: #0a4a46;\n  --teal-900: #083836;\n  --teal-950: #052524;\n  --neutral-0: #fff;\n  --neutral-50: #f4f7f7;\n  --neutral-100: #e8edec;\n  --neutral-150: #dce3e2;\n  --neutral-200: #cdd6d4;\n  --neutral-300: #aebab8;\n  --neutral-400: #8a9896;\n  --neutral-500: #6b7b78;\n  --neutral-600: #506360;\n  --neutral-700: #3a4d4a;\n  --neutral-800: #253836;\n  --neutral-900: #142624;\n  --neutral-950: #0a1614;\n  --red-50: #fef2f1;\n  --red-100: #fde3e1;\n  --red-200: #fbc5c0;\n  --red-300: #f59b93;\n  --red-400: #ed6b5f;\n  --red-500: #e04434;\n  --red-600: #c23a2b;\n  --red-700: #a3301f;\n  --red-800: #872b1d;\n  --red-900: #6f291e;\n  --green-50: #edfbf2;\n  --green-100: #d4f5e0;\n  --green-200: #ace9c5;\n  --green-300: #76d8a2;\n  --green-400: #3ec17c;\n  --green-500: #1c8a4c;\n  --green-600: #15703d;\n  --green-700: #115a33;\n  --green-800: #10472a;\n  --green-900: #0e3b24;\n  --amber-50: #fef8ec;\n  --amber-100: #fceec9;\n  --amber-200: #f9d98f;\n  --amber-300: #f5bd54;\n  --amber-400: #e9a020;\n  --amber-500: #b7701a;\n  --amber-600: #9a5b14;\n  --amber-700: #7d4412;\n  --amber-800: #663714;\n  --amber-900: #552e16;\n  --blue-50: #eff6ff;\n  --blue-100: #dbe9fe;\n  --blue-200: #bfdbfe;\n  --blue-300: #93c5fd;\n  --blue-400: #60a5fa;\n  --blue-500: #3b82f6;\n  --blue-600: #2563eb;\n  --blue-700: #1d4ed8;\n  --blue-800: #1e40af;\n  --blue-900: #1e3a8a;\n\n  /* Semantic colors — light mode, Figma 39:594 */\n  --bg-primary: var(--neutral-50);\n  --bg-secondary: var(--neutral-100);\n  --bg-tertiary: var(--neutral-150);\n  --surface-primary: var(--neutral-0);\n  --surface-secondary: var(--neutral-50);\n  --surface-tertiary: var(--neutral-100);\n  --surface-elevated: var(--neutral-0);\n  --border-default: var(--neutral-200);\n  --border-strong: var(--neutral-300);\n  --border-subtle: var(--neutral-150);\n  --text-primary: var(--neutral-900);\n  --text-secondary: var(--neutral-600);\n  --text-tertiary: var(--neutral-500);\n  --text-disabled: var(--neutral-400);\n  --text-inverse: var(--neutral-0);\n  --text-link: var(--teal-600);\n  --interactive-default: var(--teal-600);\n  --interactive-hover: var(--teal-700);\n  --interactive-pressed: var(--teal-800);\n  --interactive-disabled: var(--neutral-200);\n  --interactive-soft: var(--teal-50);\n  --interactive-soft-hover: var(--teal-100);\n  --interactive-selected: var(--teal-100);\n  --on-interactive-primary: var(--neutral-0);\n  --on-interactive-disabled: var(--neutral-400);\n  --focus-ring: var(--teal-200);\n  --danger-default: var(--red-600);\n  --danger-soft: var(--red-50);\n  --danger-text: var(--red-700);\n  --danger-border: var(--red-200);\n  --success-default: var(--green-600);\n  --success-soft: var(--green-50);\n  --success-text: var(--green-700);\n  --success-border: var(--green-200);\n  --warning-default: var(--amber-500);\n  --warning-soft: var(--amber-50);\n  --warning-text: var(--amber-700);\n  --warning-border: var(--amber-200);\n  --info-default: var(--blue-600);\n  --info-soft: var(--blue-50);\n  --info-text: var(--blue-700);\n  --info-border: var(--blue-200);\n  --money-overdue: var(--red-600);\n  --money-overdue-soft: var(--red-50);\n  --money-paid: var(--green-600);\n  --money-paid-soft: var(--green-50);\n  --money-pending: var(--amber-500);\n  --money-pending-soft: var(--amber-50);\n  --money-draft: var(--neutral-500);\n  --money-draft-soft: var(--neutral-100);\n  --chart-primary: var(--teal-600);\n  --chart-secondary: #aebab8;\n  --chart-tertiary: var(--teal-300);\n  --chart-danger: var(--red-500);\n  --chart-success: var(--green-500);\n  --chart-grid: var(--neutral-200);\n  --overlay-default: rgba(10, 22, 20, 0.4);\n  --overlay-heavy: rgba(10, 22, 20, 0.7);\n  --toast-bg: var(--neutral-900);\n  --toast-text: var(--neutral-50);\n\n  /* Brand gradient — Figma 72:89 */\n  --brand-gradient-start: #3af0f3;\n  --brand-gradient-mid: #0fbac4;\n  --brand-gradient-end: #0a7489;\n  --brand-gradient: linear-gradient(\n    135deg,\n    var(--brand-gradient-start) 0%,\n    var(--brand-gradient-mid) 45%,\n    var(--brand-gradient-end) 100%\n  );\n\n  /* Typography — desktop defaults, Figma 48:6 */\n  --font-family-primary: \"Lexend\", sans-serif;\n  --font-family-mono: \"JetBrains Mono\", monospace;\n  --font-weight-light: 300;\n  --font-weight-regular: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n  --font-size-display-hero: 56px;\n  --line-height-display-hero: 1.1;\n  --letter-spacing-display-hero: -1.12px;\n  --font-size-display-lg: 48px;\n  --line-height-display-lg: 1.15;\n  --letter-spacing-display-lg: -0.96px;\n  --font-size-display-md: 40px;\n  --line-height-display-md: 1.2;\n  --letter-spacing-display-md: -0.6px;\n  --font-size-h1: 32px;\n  --line-height-h1: 1.25;\n  --letter-spacing-h1: -0.48px;\n  --font-size-h2: 28px;\n  --line-height-h2: 1.3;\n  --letter-spacing-h2: -0.28px;\n  --font-size-h3: 22px;\n  --line-height-h3: 1.35;\n  --letter-spacing-h3: -0.22px;\n  --font-size-h4: 18px;\n  --line-height-h4: 1.4;\n  --letter-spacing-h4: -0.09px;\n  --font-size-h5: 16px;\n  --line-height-h5: 1.4;\n  --letter-spacing-h5: 0;\n  --font-size-h6: 14px;\n  --line-height-h6: 1.45;\n  --letter-spacing-h6: 0;\n  --font-size-body-lg: 18px;\n  --line-height-body-lg: 1.6;\n  --letter-spacing-body-lg: 0;\n  --font-size-body-md: 16px;\n  --line-height-body-md: 1.6;\n  --letter-spacing-body-md: 0;\n  --font-size-body-sm: 14px;\n  --line-height-body-sm: 1.55;\n  --letter-spacing-body-sm: 0;\n  --font-size-body-xs: 12px;\n  --line-height-body-xs: 1.5;\n  --letter-spacing-body-xs: 0.12px;\n  --font-size-label-lg: 16px;\n  --line-height-label-lg: 1.3;\n  --letter-spacing-label-lg: 0;\n  --font-size-label-md: 14px;\n  --line-height-label-md: 1.3;\n  --letter-spacing-label-md: 0.07px;\n  --font-size-label-sm: 12px;\n  --line-height-label-sm: 1.3;\n  --letter-spacing-label-sm: 0.12px;\n  --font-size-caption-md: 13px;\n  --line-height-caption-md: 1.4;\n  --letter-spacing-caption-md: 0.065px;\n  --font-size-caption-sm: 11px;\n  --line-height-caption-sm: 1.45;\n  --letter-spacing-caption-sm: 0.12px;\n  --font-size-overline: 11px;\n  --line-height-overline: 1.3;\n  --letter-spacing-overline: 0.88px;\n  --font-size-doc-number: 14px;\n  --line-height-doc-number: 1.3;\n  --letter-spacing-doc-number: 0.28px;\n  --font-size-money-hero: 56px;\n  --line-height-money-hero: 1.1;\n  --letter-spacing-money-hero: -1.12px;\n  --font-size-money-lg: 22px;\n  --line-height-money-lg: 1.2;\n  --letter-spacing-money-lg: 0;\n  --font-size-money-md: 16px;\n  --line-height-money-md: 1.3;\n  --letter-spacing-money-md: 0;\n  --font-size-money-sm: 14px;\n  --line-height-money-sm: 1.3;\n  --letter-spacing-money-sm: 0;\n\n  /* Spacing, controls, radii, elevation — Figma 54:37 */\n  --space-0: 0;\n  --space-px: 1px;\n  --space-1: 4px;\n  --space-2: 8px;\n  --space-3: 12px;\n  --space-4: 16px;\n  --space-5: 20px;\n  --space-6: 24px;\n  --space-8: 32px;\n  --space-10: 40px;\n  --space-12: 48px;\n  --space-16: 64px;\n  --space-20: 80px;\n  --space-24: 96px;\n  --control-sm: 32px;\n  --control-md: 40px;\n  --control-lg: 48px;\n  --radius-none: 0;\n  --radius-xs: 4px;\n  --radius-sm: 6px;\n  --radius-md: 10px;\n  --radius-lg: 14px;\n  --radius-xl: 20px;\n  --radius-pill: 999px;\n  --radius-full: 9999px;\n  --elevation-none: none;\n  --elevation-small: 0 1px 2px rgba(14, 26, 32, 0.06);\n  --elevation-medium: 0 1px 2px rgba(14, 26, 32, 0.04),\n    0 6px 16px -4px rgba(14, 26, 32, 0.1);\n  --elevation-large: 0 2px 6px rgba(14, 26, 32, 0.06),\n    0 24px 48px -12px rgba(14, 26, 32, 0.22);\n  --elevation-xlarge: 0 4px 8px rgba(14, 26, 32, 0.08),\n    0 32px 64px -16px rgba(14, 26, 32, 0.28);\n  /* Focus uses borders or solid keyboard outlines instead of a glow. */\n  --focus-shadow: none;\n\n  /* Iconography — Figma 59:8 */\n  --icon-xs: 12px;\n  --icon-sm: 16px;\n  --icon-md: 20px;\n  --icon-lg: 24px;\n  --icon-xl: 32px;\n  --icon-stroke: 2px;\n\n  /* Motion — Figma 67:130 */\n  --duration-instant: 0ms;\n  --duration-fast: 100ms;\n  --duration-normal: 200ms;\n  --duration-moderate: 300ms;\n  --duration-slow: 400ms;\n  --duration-slower: 500ms;\n  --easing-out: cubic-bezier(0.16, 1, 0.3, 1);\n  --easing-in: cubic-bezier(0.55, 0, 1, 0.45);\n  --easing-in-out: cubic-bezier(0.45, 0, 0.55, 1);\n  --easing-linear: linear;\n}\n\n[data-theme=\"dark\"],\n.theme-dark {\n  --bg-primary: #101113;\n  --bg-secondary: #17191c;\n  --bg-tertiary: #202328;\n  --surface-primary: #191b1f;\n  --surface-secondary: #22252a;\n  --surface-tertiary: #2b2f35;\n  --surface-elevated: #25282e;\n  --border-default: #3a3f47;\n  --border-strong: #69727e;\n  --border-subtle: #2c3036;\n  --text-primary: #f2f3f5;\n  --text-secondary: #b3b8c2;\n  --text-tertiary: #9299a5;\n  --text-disabled: #616975;\n  --text-inverse: #101113;\n  --text-link: #83c7be;\n  --interactive-default: #43a79c;\n  --interactive-hover: #83c7be;\n  --interactive-pressed: #b6ded8;\n  --interactive-disabled: #30343b;\n  --interactive-soft: #22252a;\n  --interactive-soft-hover: #2b2f35;\n  --interactive-selected: #083836;\n  --on-interactive-primary: #101113;\n  --on-interactive-disabled: #727b88;\n  --focus-ring: #71c9be;\n  --danger-default: #f08078;\n  --danger-soft: #332022;\n  --danger-text: #f3aaa4;\n  --danger-border: #614047;\n  --success-default: #61bc8c;\n  --success-soft: #1b2d25;\n  --success-text: #94d3af;\n  --success-border: #3f6650;\n  --warning-default: #ddb56b;\n  --warning-soft: #342b1d;\n  --warning-text: #e6c78c;\n  --warning-border: #695638;\n  --info-default: #7fa8db;\n  --info-soft: #1e2b3c;\n  --info-text: #aec9ec;\n  --info-border: #415c82;\n  --overlay-default: #0009;\n  --overlay-heavy: #000c;\n  --toast-bg: #25282e;\n  --toast-text: #f2f3f5;\n  --money-overdue: #f08078;\n  --money-overdue-soft: #332022;\n  --money-paid: #61bc8c;\n  --money-paid-soft: #1b2d25;\n  --money-pending: #ddb56b;\n  --money-pending-soft: #342b1d;\n  --money-draft: #b3b8c2;\n  --money-draft-soft: #22252a;\n  --chart-primary: #43a79c;\n  --chart-secondary: #77817c;\n  --chart-tertiary: #97a6bf;\n  --chart-danger: #f08078;\n  --chart-success: #61bc8c;\n  --chart-grid: #343940;\n}\n\n/* Semantic type styles from the shared Figma typography scale (48:6). */\n.type-display-hero {\n  font: var(--font-weight-light) var(--font-size-display-hero) /\n    var(--line-height-display-hero) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-display-hero);\n}\n.type-display-lg {\n  font: var(--font-weight-light) var(--font-size-display-lg) /\n    var(--line-height-display-lg) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-display-lg);\n}\n.type-display-md {\n  font: var(--font-weight-light) var(--font-size-display-md) /\n    var(--line-height-display-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-display-md);\n}\n.type-h1 {\n  font: var(--font-weight-semibold) var(--font-size-h1) / var(--line-height-h1)\n    var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-h1);\n}\n.type-h2 {\n  font: var(--font-weight-semibold) var(--font-size-h2) / var(--line-height-h2)\n    var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-h2);\n}\n.type-h3 {\n  font: var(--font-weight-medium) var(--font-size-h3) / var(--line-height-h3)\n    var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-h3);\n}\n.type-h4 {\n  font: var(--font-weight-medium) var(--font-size-h4) / var(--line-height-h4)\n    var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-h4);\n}\n.type-h5 {\n  font: var(--font-weight-medium) var(--font-size-h5) / var(--line-height-h5)\n    var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-h5);\n}\n.type-h6 {\n  font: var(--font-weight-medium) var(--font-size-h6) / var(--line-height-h6)\n    var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-h6);\n}\n.type-body-lg {\n  font: var(--font-weight-regular) var(--font-size-body-lg) /\n    var(--line-height-body-lg) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-body-lg);\n}\n.type-body-md {\n  font: var(--font-weight-regular) var(--font-size-body-md) /\n    var(--line-height-body-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-body-md);\n}\n.type-body-sm {\n  font: var(--font-weight-regular) var(--font-size-body-sm) /\n    var(--line-height-body-sm) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-body-sm);\n}\n.type-body-xs {\n  font: var(--font-weight-regular) var(--font-size-body-xs) /\n    var(--line-height-body-xs) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-body-xs);\n}\n.type-label-lg {\n  font: var(--font-weight-medium) var(--font-size-label-lg) /\n    var(--line-height-label-lg) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-label-lg);\n}\n.type-label-md {\n  font: var(--font-weight-medium) var(--font-size-label-md) /\n    var(--line-height-label-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-label-md);\n}\n.type-label-sm {\n  font: var(--font-weight-medium) var(--font-size-label-sm) /\n    var(--line-height-label-sm) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-label-sm);\n}\n.type-caption-md {\n  font: var(--font-weight-regular) var(--font-size-caption-md) /\n    var(--line-height-caption-md) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-caption-md);\n}\n.type-caption-sm {\n  font: var(--font-weight-regular) var(--font-size-caption-sm) /\n    var(--line-height-caption-sm) var(--font-family-primary);\n  letter-spacing: var(--letter-spacing-caption-sm);\n}\n.type-doc-number {\n  font: var(--font-weight-medium) var(--font-size-doc-number) /\n    var(--line-height-doc-number) var(--font-family-mono);\n  letter-spacing: var(--letter-spacing-doc-number);\n}\n.type-money-hero {\n  font: var(--font-weight-bold) var(--font-size-money-hero) /\n    var(--line-height-money-hero) var(--font-family-mono);\n  letter-spacing: var(--letter-spacing-money-hero);\n}\n.type-money-lg {\n  font: var(--font-weight-bold) var(--font-size-money-lg) /\n    var(--line-height-money-lg) var(--font-family-mono);\n  letter-spacing: var(--letter-spacing-money-lg);\n}\n.type-money-md {\n  font: var(--font-weight-medium) var(--font-size-money-md) /\n    var(--line-height-money-md) var(--font-family-mono);\n  letter-spacing: var(--letter-spacing-money-md);\n}\n.type-money-sm {\n  font: var(--font-weight-regular) var(--font-size-money-sm) /\n    var(--line-height-money-sm) var(--font-family-mono);\n  letter-spacing: var(--letter-spacing-money-sm);\n}\n\n@media (max-width: 1023px) {\n  :root {\n    --font-size-display-hero: 48px;\n    --font-size-display-lg: 40px;\n    --font-size-display-md: 34px;\n    --font-size-h1: 28px;\n    --font-size-h2: 24px;\n    --font-size-h3: 20px;\n    --font-size-h4: 17px;\n    --font-size-h5: 15px;\n    --font-size-h6: 13px;\n    --font-size-body-lg: 17px;\n    --font-size-body-md: 15px;\n    --font-size-body-sm: 13px;\n    --font-size-body-xs: 12px;\n    --font-size-label-lg: 15px;\n    --font-size-label-md: 13px;\n    --font-size-label-sm: 12px;\n    --font-size-money-hero: 48px;\n    --font-size-money-lg: 20px;\n    --font-size-money-md: 15px;\n    --font-size-money-sm: 13px;\n  }\n}\n@media (max-width: 600px) {\n  :root {\n    --font-size-display-hero: 36px;\n    --font-size-display-lg: 32px;\n    --font-size-display-md: 28px;\n    --font-size-h1: 24px;\n    --font-size-h2: 20px;\n    --font-size-h3: 18px;\n    --font-size-h4: 16px;\n    --font-size-h5: 15px;\n    --font-size-h6: 13px;\n    --font-size-body-lg: 17px;\n    --font-size-body-md: 15px;\n    --font-size-body-sm: 13px;\n    --font-size-body-xs: 12px;\n    --font-size-label-lg: 15px;\n    --font-size-label-md: 13px;\n    --font-size-label-sm: 11px;\n    --font-size-money-hero: 36px;\n    --font-size-money-lg: 20px;\n    --font-size-money-md: 15px;\n    --font-size-money-sm: 13px;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
